import axios from "axios";
import store from "./Redux/store.js";
import { openModal, setModalOptions } from "./Redux/actions/ui.js";

const resolveApiBaseURL = () => {
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;

    if (host.includes('staging.inventum3d.com')) {
      return 'https://api-staging.inventum3d.com';
    }
  }

  return 'https://api.inventum3d.com';
};

export const API_BASE_URL = resolveApiBaseURL();
export const GEOSERVER_BASE_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_GEOSERVER_BASE_URL) ||
  'https://api.inventum3d.com/geoserver';

var axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json", // Default for JSON requests
  },
});

const AUTH_PROMPT_EXCLUDED_PATHS = [
  "/authenticate",
  "/reauthenticate",
  "/register",
  "/forgotpassword",
  "/resetpassword",
];

const getRequestPath = (url = "") => {
  try {
    return new URL(url, API_BASE_URL).pathname;
  } catch (error) {
    return String(url).split("?")[0];
  }
};

export const isAuthFailure = (error) => {
  return !!(error && error.response && error.response.status === 401);
};

export const isSessionPromptExcludedRequest = (url = "") => {
  const path = getRequestPath(url);
  return AUTH_PROMPT_EXCLUDED_PATHS.includes(path);
};

export const shouldPromptSessionExpired = (error) => {
  return isAuthFailure(error) && !isSessionPromptExcludedRequest(error.config && error.config.url);
};

export const promptSessionExpired = () => {
  const state = store.getState ? store.getState() : {};
  const modalOptions = (state.ui && state.ui.modalOptions) || {};

  if (state.ui && state.ui.activeModal === "ReAuthorize" && modalOptions.sessionExpired) {
    return;
  }

  store.dispatch(setModalOptions({ sessionExpired: true }));
  store.dispatch(openModal("ReAuthorize"));
};

axiosInstance.interceptors.request.use((config) => {
  let token = localStorage.getItem("inventumToken");
  if (token !== null) {
    config.headers = Object.assign(
      {
        Authorization: token,
      },
      config.headers
    );
  }

  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
    console.log("FormData detected - Content-Type header removed");
  }

  // Debugging info
  if (process.env.NODE_ENV === "development") {
    console.log(`Axios-config logs in development mode. Check axios-config.js for more details.`);
    if (config.data instanceof FormData) {
      console.log(`FormData request to ${config.url}`);
    } else {
      const size = config.data ? JSON.stringify(config.data).length : 0;
      console.log(`Request to ${config.url}, size: ${(size / 1024 / 1024).toFixed(2)} MB`);
    }
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldPromptSessionExpired(error)) {
      promptSessionExpired();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
